import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './WaterfallPreviewer.styles';

import { WATERFALL_ICON } from '~/core/constants';
import { SideItemOption } from '~/core/enums';
import { useDrawingShapeContext } from '~contexts';

const WaterfallPreviewer = (): JSX.Element => {
  const {
    getters: { drawingShapes, areThereShapesInTheDrawingArea },
  } = useDrawingShapeContext();
  const { t } = useTranslation();

  const doesWaterfallExist = useMemo((): boolean => {
    if (!drawingShapes || !areThereShapesInTheDrawingArea) {
      return false;
    }

    return drawingShapes.some((shape) =>
      shape.drawingEdges.some(
        (edge) => edge.sideItem?.type === SideItemOption.WATERFALL
      )
    );
  }, [areThereShapesInTheDrawingArea, drawingShapes]);

  return (
    <>
      {doesWaterfallExist && (
        <St.Container>
          <St.WaterfallPreviewerImage
            alt="waterfall-preview"
            src={WATERFALL_ICON}
          />
          <St.WaterfallName>{t('WATERFALL.TITLE')}</St.WaterfallName>
        </St.Container>
      )}
    </>
  );
};

export default WaterfallPreviewer;
